module.exports = __webpack_public_path__ + "img/ad.4d7c8e1d.jpg";